import { Skeleton } from '@design-system';
import { FC } from 'react';

export const SkeletonCta: FC = () => (
  <div className="flex w-full flex-col items-center gap-3">
    <Skeleton className="h-5 w-1/2" />
    <div className="flex w-full flex-col items-center gap-1">
      <Skeleton className="h-4 w-4/5" />
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-4 w-2/3" />
    </div>
    <Skeleton className="h-14 w-full" />
  </div>
);
